wbApp.controller('ReservationSchedulesCtrl', ['$scope', '$modal', '$translate', '$q', '$timeout',
    'classroomSvc', 'employeeSvc', 'classroomAvailabilitySchedulesSvc', 'messageBoxSvc', 'reservationsSvc',
    'localStorageService', 'userSvc', 'studentSvc', 'tenantInfo', 'pricingSvc', 'domainsSvc',
function ($scope, $modal, $translate, $q, $timeout, classroomSvc, employeeSvc, classroomAvailabilitySchedulesSvc,
    messageBoxSvc, reservationsSvc, localStorageService, userSvc, studentSvc, tenantInfo, pricingSvc, domainsSvc) {

    function getCurrencySymbol(tenantInfo) {
        switch (tenantInfo.currency) {
            case 'CZK':
                return ' Kč';
            case 'EUR':
                return ' €';
            default:
                return ' Kč';
        }
    }

    var model = {};
    var data = [];
    var availableCache = {};

    var employeesForDateRangePromise = null;
   
    var now = null;
    if (localStorageService.isSupported) {
        var nowStr = localStorageService.get('reservation-schedule-selected-date');
        if (!!nowStr) {
            now = new Date(JSON.parse(nowStr));
        }
        else {
            now = moment().startOf('day').toDate();
        }
    } else {
        now = moment().startOf('day').toDate();
    }


    $scope.selectedClassroom = null;
    var activeClassrooms = classroomSvc.getAllActiveAsync( /* classroomIDtoInclude */ null, /* filterForReservations */ true, /* filterForCourses */ false).$promise;

    var classrooms = $q(function (resolve, reject) { activeClassrooms.then(
        function (data) {
            resolve(_.map(data, function (c) {
                return {
                    id: c.id + "",
                    name: c.name
                }
            }));
        },
        function (error) {
            reject(error);
        });
    });

    var classroomDataSource = new DevExpress.data.DataSource({
        key:["id"],
        load: function (loadOptions) {            
            return classrooms;
        },
        byKey: function (e) {
            return $q(function (resolve, reject) {
                classrooms.then(
                    function (data) {
                        var place = _.find(data, { id: e });
                        resolve(place);
                    },
                    function (error) {
                        reject(error);
                    });
            });
        },
        loadMode: 'raw'
    });

    classrooms.then(function (data) {
        if (localStorageService.isSupported) {
            $scope.selectedClassroom = localStorageService.get('reservation-schedule-selected-classroom');            
        }
    });

    var employees = null;
    var classroomAvailiability = null;
    var employeesShallow = employeeSvc.getAll();
    $scope.selectedEmployees = [];
    var lastFilteredEmployeeSchedules = [];
    var relaodDueToResources = false;

    $scope.getDomain = function (domainId) {
        return _.find(domains, { 'id': domainId });
    }

    $scope.getSpecialization = function (domain, specializationId) {
        return _.find(domain.specializations, { 'id': specializationId });
    }
    
    function resolveDomainAndSpecialization(domainOrSpecializationId) {
        var result = {
            domainId: null,
            domainSpecializationId: null
        };
        
        _.find(domains, function (d) {
            if (d.id === domainOrSpecializationId) {
                result = {
                    domainId: domainOrSpecializationId,
                    domainSpecializationId: null
                };
                return true;
            }
            let specialization = _.find(d.specializations, { id: domainOrSpecializationId });
            if (!!specialization) {
                result = {
                    domainId: d.id,
                    domainSpecializationId: domainOrSpecializationId
                };
                return true;
            }
            return false;
        });
        
        return result;
    }

    var domains = domainsSvc.getAllExpanded();
    var domainsDataSource = new DevExpress.data.DataSource({
        load: function (loadOptions) {
            return domains.$promise;
        },
        byKey: function (e) {
            return $q(function (resolve, reject) {
                domains.$promise.then(function (data) {
                    _.forEach(data, function (d) {
                        if (d.id == e) {
                            resolve(d);
                            return d;
                        }

                        var found = false;

                        _.forEach(d.specializations, function (s) {
                            if (s.id == e) {
                                resolve(s);
                                found = true;
                                return s;
                            }
                        })

                        if (found) {
                            return;
                        }
                    });
                },
                function (error) {
                    reject(error);
                })
            })
        },
        loadMode: 'processed'
    });

    var refreshUsersDataSource = false;

    var userDataSource = new DevExpress.data.DataSource({
        load: function (loadOptions) {
            return $q(function (resolve, reject) {
                userSvc.getAllBrief(refreshUsersDataSource).then(
                function (data) {
                    refreshUsersDataSource = false;
                    resolve(data);
                },
                function (error) {
                    refreshUsersDataSource = false;
                    reject(error);
                })
            });
        },
        byKey: function(e) {
            return $q(function (resolve, reject) {
                userSvc.getAllBrief(refreshUsersDataSource).then(
                    function (data) {
                        refreshUsersDataSource = false;
                        resolve(_.find(data, { id: e + "" }));
                    },
                    function (error) {
                        refreshUsersDataSource = false;
                        reject(error);
                    });
            });
        },
        loadMode: 'raw'
    });

    var selectedUserId = null;
    var refreshStudentsDataSource = false;
    var studentsDataSource = new DevExpress.data.DataSource({
        load: function (loadOptions) {
            return $q(function (resolve, reject) {
                if (!!selectedUserId) {
                    studentSvc.getAllByUserIDAsync(selectedUserId, refreshStudentsDataSource).$promise.then(function (data) {
                        resolve(data);
                    }, function (error) {
                        reject(error);
                    });
                } else {
                    resolve([]);
                }
            });
        },
        byKey: function (e) {
            return null;
        }
    });

    var lastError = null;

    var scheduleDataSource = new DevExpress.data.DataSource({
        store: new DevExpress.data.CustomStore({
            load: function (loadOptions) {
                return $q(function (resolve, reject) {

                    availableCache = {};

                    if (!canLoadData()) {
                        resolve([]);
                        return;
                    }

                    if (relaodDueToResources)
                    {
                        resolve(lastFilteredEmployeeSchedules);
                        relaodDueToResources = false;
                        return;
                    }

                    var employeeSchedules = [];

                    var startDate = moment(/*loadOptions.dxScheduler.startDate*/schedulerInstance.getStartViewDate()).startOf('day').toDate();
                    var endDate = moment(/*loadOptions.dxScheduler.endDate*/schedulerInstance.getEndViewDate()).startOf('day').toDate();
                
                    employeesForDateRangePromise = employeeSvc.getAllExpanded(startDate, endDate);
                    var classroomAvailabilityPromise = classroomAvailabilitySchedulesSvc.loadDay($scope.selectedClassroom, startDate);
                    var reservationsPromise = reservationsSvc.getAllByRangeAndPlace($scope.selectedClassroom, startDate, endDate);

                    $q.all([employeesForDateRangePromise, classroomAvailabilityPromise, reservationsPromise, domains.$promise]).then(
                        function (data) {
                            var selectedEmployees = _.sortBy(_.filter(data[0], function (e) {
                                return e.availability.length > 0 || e.schedule.length > 0;
                            }), ['surname', 'name']);

                            employees = _.keyBy(selectedEmployees, 'id');
                            classroomAvailiability = data[1];

                            _.forEach(classroomAvailiability.periods, function (p) {
                                var start = moment(p.start);
                                var end = moment(p.end);
                                while (start.isBefore(end)) {
                                    var id = "time-cell-" + start.format('HHmm');
                                    angular.element('#' + id).addClass('place-available');

                                    start.add(30, 'm');
                                }
                            });

                            _.forEach(selectedEmployees, function (e) {
                                if (e.schedule.length > 0) {
                                    var periods = 
                                        _.map(e.schedule[0].periods, function (s) {
                                            return {
                                                employeeId: e.id,
                                                userId: e.userId,
                                                fullName: e.fullName,
                                                startDate: s.start,
                                                placeId: s.placeId,                                            
                                                endDate: s.end,
                                                type: 0
                                            };
                                        });
                                    employeeSchedules.push.apply(employeeSchedules, periods);
                                }
                            });

                            lastError = null;

                            var filteredEmployeeSchedules = _.filter(employeeSchedules, { placeId: $scope.selectedClassroom + "" });

                            var reservations = _.map(data[2], function (r) {
                                return {
                                    id: r.id,
                                    employeeId: r.employeeId,
                                    userId: r.userId,
                                    placeId: r.placeId,
                                    startDate: r.reservationStartDate,
                                    endDate: r.reservationEndDate,
                                    template: 'reservationCellTemplate',
                                    type: 1,
                                    studentsIds: r.studentIds,
                                    price: r.price,
                                    notes: r.notes,
                                    domainId: !!r.domainSpecialization ? r.domainSpecialization.id: r.domain.id,
                                    domainName: $scope.getDomain(r.domain.id).name,
                                    domainSpecializationName: !!r.domainSpecialization
                                        ? $scope.getSpecialization($scope.getDomain(r.domain.id), r.domainSpecialization.id).name
                                        : '',
                                    students: _.map(r.students, function (s) {
                                        var mbirthday = !!s.birthday
                                            ? moment(s.birthday)
                                            : null;
                                        var age = null;
                                        if (!!mbirthday && mbirthday.isValid()) {
                                            if ((moment().diff(mbirthday, 'years') < 16) &&
                                                (moment().diff(mbirthday, 'months') >= 1)) {
                                                age = mbirthday.toNow(true);
                                            }
                                        }
                                        return {
                                            fullName: String.prototype.fullName(s.name, s.middlename, s.surname),
                                            age: age
                                        }
                                    }),
                                    arrear: r.invoice.arrear,
                                    invoiceId: r.invoice.id
                                }
                            });

                            filteredEmployeeSchedules.push.apply(filteredEmployeeSchedules, reservations);

                            if (!angular.equals($scope.selectedEmployees, selectedEmployees)) {
                                relaodDueToResources = true;
                                lastFilteredEmployeeSchedules = filteredEmployeeSchedules;
                                $scope.selectedEmployees = selectedEmployees;
                            }
                            resolve(filteredEmployeeSchedules);
                        },
                        function (error) {
                            employees = null;
                            classroomAvailiability = null;
                            lastError = error.data;
                            reject(error.data.title);
                        }
                    );                
                })
            },
            insert: function (data) {
                return $q(function (resolve, reject) {

                    if (data.type == 0) {
                        var employeeData = employees[data.employeeId];
                        if (employeeData && $scope.selectedClassroom) {

                            var employeeDataCopy = angular.copy(employeeData);

                            if (employeeDataCopy.schedule.length == 0) {
                                employeeDataCopy.schedule.push({
                                    day: moment(data.startDate).startOf('day').toDate(),
                                    periods: [{
                                        placeId: $scope.selectedClassroom,
                                        start: data.startDate,
                                        end: data.endDate
                                    }]
                                });
                            } else {
                                employeeDataCopy.schedule[0].periods.push({
                                    placeId: $scope.selectedClassroom,
                                    start: data.startDate,
                                    end: data.endDate
                                });
                            }

                            employeeSvc.schedulesUpdateDay(
                                data.employeeId,
                                moment(data.startDate).startOf('day').toDate(),
                                employeeDataCopy.schedule[0]).$promise
                           .then(
                                function (success) {
                                    resolve();
                                },
                                function (error) {
                                    lastError = error.data;
                                    reject(error.data.title);
                                });
                        }
                        else {
                            resolve();
                        }
                    }
                    else if (data.type == 1) {
                        var specialization = null;
                        var domain = _.find(domains, function (d) {
                            if (d.id == data.domainId) {
                                return true;
                            }
                            specialization = _.find(d.specializations, { id: data.domainId });
                            if (!!specialization) {
                                return true;
                            }
                            return false;
                        });

                        reservationsSvc.insert({
                            employeeId: data.employeeId,
                            placeId: data.placeId,
                            price: data.price,
                            studentIds: data.studentsIds,
                            registrationDate: new Date(),
                            reservationStartDate: data.startDate,
                            reservationEndDate: data.endDate,
                            userId: data.userId,
                            notes: data.notes || '',
                            domain: { id: domain.id },
                            createEmployeeScheduleIfMissing: data.createEmployeeScheduleIfMissing,
                            domainSpecialization: !!specialization ? { id: specialization.id } : null
                        }).$promise
                        .then(function (success) {
                            resolve();
                        }, function (error) {
                            reject(error.data.title);
                        });                        
                    }
                });
            },
            update: function(oldData, newData) {                
                return $q(function (resolve, reject) {
                    if (newData.type == 0) {
                        var employeeData = employees[oldData.employeeId];
                        if (employeeData && $scope.selectedClassroom && employeeData.schedule.length == 1) {

                            var employeeDataCopy = angular.copy(employeeData);

                            var affectedPeriod = _.find(employeeDataCopy.schedule[0].periods, function (p) {
                                var periodStartDate = moment(p.start);
                                var periodEndDate = moment(p.end);

                                return periodStartDate.isSame(oldData.startDate) &&
                                       periodEndDate.isSame(oldData.endDate);
                            });
                            if (affectedPeriod) {
                                affectedPeriod.start = newData.startDate;
                                affectedPeriod.end = newData.endDate;

                                employeeSvc.schedulesUpdateDay(
                                    oldData.employeeId,
                                    moment(newData.startDate).startOf('day').toDate(),
                                    employeeDataCopy.schedule[0]).$promise
                               .then(
                                    function (success) {
                                        resolve();
                                        return;
                                    },
                                    function (error) {
                                        lastError = error.data;
                                        reject(error.data.title);
                                        return;
                                    });
                            }
                            else {
                                resolve();
                            }
                        }
                        else {
                            resolve();
                        }
                    } else if (newData.type == 1) {

                        var specialization = null;
                        var domain = _.find(domains, function (d) {
                            if (d.id == newData.domainId) {
                                return true;
                            }
                            specialization = _.find(d.specializations, { id: newData.domainId });
                            if (!!specialization) {
                                return true;
                            }
                            return false;
                        });
                        
                        if (newData.employeeIds && newData.employeeIds.length > 0) {
                            let promises = [];
                            newData.employeeIds.forEach(function (employeeId) {
                                promises.push(
                                    reservationsSvc.insert({
                                        employeeId: employeeId,
                                        placeId: newData.placeId,
                                        price: newData.price,
                                        studentIds: newData.studentsIds,
                                        registrationDate: new Date(),
                                        reservationStartDate: newData.startDate,
                                        reservationEndDate: newData.endDate,
                                        userId: newData.userId,
                                        notes: newData.notes || '',
                                        domain: { id: domain.id },
                                        createEmployeeScheduleIfMissing: newData.createEmployeeScheduleIfMissing,
                                        domainSpecialization: !!specialization ? { id: specialization.id } : null
                                    }).$promise
                                );
                            });
                            $q.all(promises).then(function (success) {
                                resolve();
                            }, function (error) {
                                reject(error.data.title);
                            });
                        }
                        else {
                            reservationsSvc.update({
                                id: newData.id,
                                employeeId: newData.employeeId,
                                placeId: newData.placeId,
                                price: newData.price,
                                studentIds: newData.studentsIds,
                                registrationDate: new Date(),
                                reservationStartDate: newData.startDate,
                                reservationEndDate: newData.endDate,
                                userId: newData.userId,
                                notes: newData.notes || '',
                                domain: {id: domain.id},
                                domainSpecialization: !!specialization ? {id: specialization.id} : null
                            }).$promise
                                .then(function (success) {
                                    resolve();
                                }, function (error) {
                                    reject(error.data.title);
                                });
                        }
                    }
                });
            },
            remove: function (data) {
                return $q(function (resolve, reject) {
                    if (data.type == 0) {
                        var employeeData = employees[data.employeeId];
                        if (employeeData && $scope.selectedClassroom && employeeData.schedule.length == 1) {
                            var newPeriods = _.remove(employeeData.schedule[0].periods, function (p) {
                                var periodStartDate = moment(p.start);
                                var periodEndDate = moment(p.end);

                                return periodStartDate.isSame(data.startDate) &&
                                       periodEndDate.isSame(data.endDate);
                            });

                            if (employeeData.schedule[0].periods.length == 0) {
                                // Delete day
                                employeeSvc.schedulesDeleteDay(
                                    data.employeeId,
                                    moment(data.startDate).startOf('day').toDate()
                                    ).$promise
                               .then(
                                    function (success) {
                                        resolve();
                                        return;
                                    },
                                    function (error) {
                                        lastError = error.data;
                                        reject(error.data.title);
                                        return;
                                    });
                            }
                            else {
                                // Update day
                                employeeSvc.schedulesUpdateDay(
                                    data.employeeId,
                                    moment(data.startDate).startOf('day').toDate(),
                                    employeeData.schedule[0]).$promise
                               .then(
                                    function (success) {
                                        resolve();
                                        return;
                                    },
                                    function (error) {
                                        lastError = error.data;
                                        reject(error.data.title);
                                        return;
                                    });
                            }
                        }
                        else {
                            resolve();
                        }
                    } else if (data.type == 1) {
                        reservationsSvc.remove(data.id).$promise.then(
                            function (data) {
                                resolve();
                            },
                            function (error) {
                                reject(error.data.title);
                            })
                    } else
                    {
                        resolve();
                    }
                });
            },
            errorHandler: function (error) {
                messageBoxSvc.showMessageDlg({
                    title: 'TXT_ALERT_TITLE_ENTITY_SAVE_ERROR',
                    message: error.message,
                    buttons: [{
                        text: 'TXT_BTN_OK'
                    }]
                });
            },
            loadMode: 'processed'
        })
    });

    function canLoadData() {
        return !!$scope.selectedClassroom;
    }

    $scope.classroomSelectOptions = {
        dataSource: classroomDataSource,
        bindingOptions: {           
            value: 'selectedClassroom'
        },
        valueExpr: 'id',
        displayExpr: 'name',
        onValueChanged: function (v) {
            if (v.previousValue != v.value) {
                if (canLoadData()) {
                    schedulerInstance.repaint();
                }
                if (!!v.value && localStorageService.isSupported) {
                    localStorageService.set('reservation-schedule-selected-classroom', v.value);
                }
            }
        }
    };

    $scope.employeeSelectOptions = {
        dataSource: $scope.selectedEmployees,
        bindingOptions: {
            value: 'selectedEmployees'
        },
        valueExpr: 'id',
        displayExpr: 'fullName',
        showSelectionControls: true,
        applyValueMode: "useButtons",
        multiline: false,
        onValueChanged: function (v) {
            if (v.previousValue != v.value ) {
                if (canLoadData()) {
                    schedulerInstance.repaint();
                }
                if (!!v.value && localStorageService.isSupported) {
                    localStorageService.set('reservation-schedule-selected-employees', v.value);
                }
            }
        }
    };

    function createEmployeeReservation(e) {
        var appointmentData = angular.copy($scope.cellContextMenuCellData);
        appointmentData.type = 0; // employee-reservation

        schedulerInstance.showAppointmentPopup(appointmentData, true, {});
    }

    function createStudentsBooking(e) {
        var appointmentData = angular.copy($scope.cellContextMenuCellData);
        appointmentData.type = 1; // student-booking

        appointmentData.studentsIds = [];
        appointmentData.userId = null;

        schedulerInstance.showAppointmentPopup(appointmentData, true, {});
    }

    $scope.cellContextMenuItems = [
        { text: $translate.instant('TXT_TEACHER_SCHEDULE_RESERVATION'), onItemClick: createEmployeeReservation },
        { text: $translate.instant('TXT_CREATE_RESERVATION'), onItemClick: createStudentsBooking }
    ];

    $scope.emptyCellContextMenuOptions = {
        dataSource: $scope.cellContextMenuItems,
        target: '.dx-scheduler-date-table-cell',
        onItemClick: function(e) {
            e.itemData.onItemClick(e.itemData);
        }
    }

    function setUpEmployeeReservationForm(data) 
    {
        var form = data.form;
        var formData = form.option('formData');
        var startDate = data.appointmentData.startDate;
        var employeeData = employees[data.appointmentData.employeeId];

        var tbStartDate, tbEndDate;

        const popup = data.element.find(".dx-scheduler-appointment-popup").dxPopup("instance");

        popup.option('title', $translate.instant('TXT_TEACHER_SCHEDULE_RESERVATION'));

        var buttons = popup.option('toolbarItems');
        buttons[1].options = {
            onClick: function () {
                popup.hide();
                if (lastError) {
                    data.component.repaint();
                }
            }
        };

        form.option("colCount", 1);
        form.option("items", [{
            label: {
                text: $translate.instant('TXT_EMPLOYEE')
            },
            name: "employee",
            editorType: "dxTextBox",
            editorOptions: {
                value: employeeData.fullName,
                readOnly: true
            },
            cssClass: 'first-form-item'
        }, {
            label: {
                text: $translate.instant('TXT_LBL_START_DATE')
            },
            dataField: "startDate",
            editorType: "dxDateBox",
            editorOptions: {
                width: "100%",
                type: "datetime",
                onInitialized: function (e) {
                    tbStartDate = e.element;
                },
                onValueChanged: function (e) {
                    if (tbEndDate) {
                        tbEndDate.dxValidator("instance").validate();
                    }
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_START_DATE'))
            }, {
                type: "custom",
                validationCallback: function (e) {
                    return moment(e.value).isBefore(formData.endDate);
                },
                reevaluate: true,
                message: $translate.instant('TXT_ERROR_MUST_BE_EARLIER_THEN_PARAM').f(
                    $translate.instant('TXT_LBL_START_DATE'),
                    $translate.instant('TXT_LBL_END_DATE')
                )
            }],
        }, {
            label: {
                text: $translate.instant('TXT_LBL_END_DATE')
            },
            name: "endDate",
            dataField: "endDate",
            editorType: "dxDateBox",
            editorOptions: {
                width: "100%",
                type: "datetime",
                onInitialized: function (e) {
                    tbEndDate = e.element;
                },
                onValueChanged: function (e) {
                    if (tbStartDate) {
                        tbStartDate.dxValidator("instance").validate();
                    }
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_END_DATE'))
            }, {
                type: "custom",
                validationCallback: function (e) {
                    return moment(e.value).isAfter(formData.startDate);
                },
                reevaluate: true,
                message: $translate.instant('TXT_ERROR_MUST_BE_LATER_THEN_PARAM').f(
                    $translate.instant('TXT_LBL_END_DATE'),
                    $translate.instant('TXT_LBL_START_DATE')
                )
            }],
        }, {
            label: {
                text: $translate.instant('TXT_PLACE')
            },
            name: "place",
            dataField: "placeId",
            editorType: "dxSelectBox",
            editorOptions: {
                dataSource: classroomDataSource,
                displayExpr: 'name',
                width: "100%",
                valueExpr: 'id',
                readOnly: true
            }
        }]);

    }

    function setUpStudentBookingForm(data)
    {
        let copyMode = data.appointmentData.copyMode || false;
        delete(data.appointmentData.copyMode);
        
        var form = data.form;
        var formData = form.option('formData');

        var startDate = formData.startDate;
        var employeeData = employees[formData.employeeId];

        var tbStartDate, tbEndDate;

        selectedUserId = formData.userId;

        function calculatePrice(d) {

            let domainAndSpecializationIds = resolveDomainAndSpecialization(d.domainId);
            
            if (!d.studentsIds || !d.studentsIds.length || !domainAndSpecializationIds.domainId)
            {
                return;
            }
            
            pricingSvc.calculateReservationPrice({
                userId: d.userId,
                placeId: d.placeId,
                studentsIds: d.studentsIds,
                employeeId: d.employeeId,
                reservationStartDate: d.startDate,
                reservationEndDate: d.endDate,
                domainId: domainAndSpecializationIds.domainId,
                domainSpecializationId: domainAndSpecializationIds.domainSpecializationId
            }, true).$promise.then(
                function (data) {
                    d.price = data.price;
                },
                function (error) {
                       
                });
        }

        const popup = data.element.find(".dx-scheduler-appointment-popup").dxPopup("instance");

        popup.option('title', $translate.instant('TXT_CREATE_RESERVATION'));

        var buttons = popup.option('toolbarItems');
        buttons[1].options = {
            onClick: function () {

                var result = form.validate();
                popup.hide();
                if (lastError) {
                    data.component.repaint();
                }
            }
        };

        var userSelectBox = null;
        var studentAddButtonInstance = null;
        
        form.option("colCount", 1);
        form.option("colCountByScreen", { xs: 1, sm: 1, md: 1, lg: 1 });
        form.option("labelLocation", "left");
        form.option("items", [
            {
            label: {
                text: $translate.instant('TXT_LBL_USER')
            },
            dataField: "userId",
            editorType: "dxSelectBox",
            editorOptions: { 
                dataSource: userDataSource,                
                displayExpr: 'fullName',
                searchExpr: ['fullName'],
                valueExpr: 'id',
                searchEnabled: true,
                readOnly: !!formData.id,
                onInitialized: function (e) {
                    userSelectBox = e.component;
                },
                buttons: ["dropDown", {
                    location: "after",
                    name: "addNewUser",
                    options: {
                        icon: "plus",
                        onClick: function() {
                            onAddUserClick().then(function (model) {
                                refreshUsersDataSource = true;                                
                                userDataSource.reload().then(function () {
                                    userSelectBox.option('value', model.id + "");
                                    selectedUserId = model.id;
                                    if (!!selectedUserId && !!studentAddButtonInstance) {
                                        studentAddButtonInstance.option('disabled', false);
                                    }
                                    formData.studentsIds = [];
                                    studentsDataSource.load();
                                });
                            });
                        }
                    }
                }],
                onValueChanged: function (v) {
                    if (v.previousValue != v.value) {
                        selectedUserId = v.value;
                        if (!!selectedUserId && !!studentAddButtonInstance) {
                            studentAddButtonInstance.option('disabled', false);
                        }
                        formData.studentsIds = [];
                        studentsDataSource.load();
                    }
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_USER'))
            }],
            cssClass: 'first-form-item'
        }, 
            {
            label: {
                text: $translate.instant('TXT_LBL_STUDENTS')
            },
            dataField: "studentsIds",
            editorType: "dxTagBox",
            editorOptions: {
                dataSource: studentsDataSource,
                displayExpr: 'fullName',
                valueExpr: 'id',
                showSelectionControls: true,
                applyValueMode: "useButtons",
                multiline: true,
                readOnly: copyMode,
                buttons: [{
                    location: "after",
                    name: "addNewStudent",
                    options: {
                        icon: "plus",
                        disabled: true,
                        onClick: function () {
                            var prom = onAddStudentClick();
                            prom.then(function (model) {
                                refreshStudentsDataSource = true;
                                studentsDataSource.reload().then(function () {
                                    formData.studentsIds.push(model.id + "");
                                });
                            });
                        },
                        onInitialized: function (e) {
                            studentAddButtonInstance = e.component;
                        },
                    }
                }],
                onValueChanged: function (v) {
                    calculatePrice(formData);
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_STUDENTS'))
            }],
        }, {
            label: {
                text: $translate.instant('TXT_DOMAIN')
            },
            dataField: "domainId",
            editorType: "dxDropDownBox",
            editorOptions: {
                dataSource: domainsDataSource,
                valueExpr: "id",
                displayExpr: "name",
                readOnly: copyMode,
                dropDownOptions: {
                    height: '300px',
                    resizeEnabled: true
                },
                contentTemplate: function(e) {
                    var $tree = $("<div>").dxTreeView(
                    {
                        dataSource: e.component.option("dataSource"),
                        dataStructure: "tree",
                        keyExpr: 'id',
                        itemsExpr: 'specializations',
                        displayExpr: "name",
                        selectByClick: true,
                        selectNodesRecursive: false,
                        selectionMode : "single",
                        onItemSelectionChanged: function (arg) {
                            if (arg.itemData.selected) {
                                e.component.option("value", arg.itemData.id);
                                e.component.close();
                            }
                        } 
                    });
                    return $tree;
                },
                onValueChanged: function (v) {
                    calculatePrice(formData);
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_DOMAIN'))
            }]
        }, {
            label: {
                text: $translate.instant('TXT_LBL_NOTE')
            },
            dataField: "notes",
            editorType: "dxTextArea",
            editorOptions: {
                height: '54px',
            }
        }, {
            label: {
                text: $translate.instant('TXT_LBL_PRICE')
            },
            dataField: "price",
            editorType: "dxNumberBox",
            editorOptions: {
                readOnly: copyMode,
                format: "#,##0.##" + getCurrencySymbol(tenantInfo),
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_PRICE'))
            }],
        }, 
            
            ... copyMode ? [] : [   
            {
                label: {
                    text: $translate.instant('TXT_EMPLOYEE')
                },
                name: "employee",
                dataField: 'employeeId',
                editorType: "dxSelectBox",
                editorOptions: {
                    dataSource: $scope.selectedEmployees,
                    displayExpr: 'fullName',
                    searchExpr: ['fullName'],
                    valueExpr: 'id',
                    searchEnabled: true,
                    onValueChanged: function (v) {
                        calculatePrice(formData);
                    }
                },
                validationRules: [{
                    type: "required",
                    message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_EMPLOYEE'))
                }],
                cssClass: 'first-form-item'
            }],

            ... copyMode ? [
            {
                label: {
                    text: $translate.instant('TXT_EMPLOYEE')
                },
                dataField: "employeeIds",
                editorType: "dxTagBox",
                editorOptions: {
                    dataSource: $scope.selectedEmployees,
                    displayExpr: 'fullName',
                    valueExpr: 'id',
                    showSelectionControls: true,
                    applyValueMode: "useButtons",
                    multiline: true,
                },
                validationRules: [{
                    type: "required",
                    message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_EMPLOYEE'))
                }],
            }] : [], 
        
        {
            label: {
                text: $translate.instant('TXT_CREATE_EMPLOYEE_SCHEDULE_IF_MISSING'),
                location: 'top',
            },
            name: "CreateEmployeeScheduleIfMissing",
            dataField: 'createEmployeeScheduleIfMissing',
            editorType: "dxCheckBox",
            cssClass: 'text-align-right'
        }, {
            label: {
                text: $translate.instant('TXT_LBL_START_DATE')
            },
            dataField: "startDate",
            editorType: "dxDateBox",
            editorOptions: {
                width: "100%",
                type: "datetime",
                onInitialized: function (e) {
                    tbStartDate = e.element;                    
                },
                onValueChanged: function (e) {
                    if (tbEndDate) {
                        tbEndDate.dxValidator("instance").validate();
                    }
                    calculatePrice(formData);
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_START_DATE'))
            }, {
                type: "custom",
                validationCallback: function (e) {
                    return moment(e.value).isBefore(formData.endDate);
                },
                reevaluate: true,
                message: $translate.instant('TXT_ERROR_MUST_BE_EARLIER_THEN_PARAM').f(
                    $translate.instant('TXT_LBL_START_DATE'),
                    $translate.instant('TXT_LBL_END_DATE')
                )
            }],
        }, {
            label: {
                text: $translate.instant('TXT_LBL_END_DATE')
            },
            name: "endDate",
            dataField: "endDate",
            editorType: "dxDateBox",
            editorOptions: {
                width: "100%",
                type: "datetime",
                onInitialized: function (e) {
                    tbEndDate = e.element;
                },
                onValueChanged: function (e) {
                    if (tbStartDate) {
                        tbStartDate.dxValidator("instance").validate();
                    }
                    calculatePrice(formData);
                }
            },
            validationRules: [{
                type: "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_LBL_END_DATE'))
            }, {
                type: "custom",
                validationCallback: function (e) {
                    return moment(e.value).isAfter(formData.startDate);
                },
                reevaluate: true,
                message: $translate.instant('TXT_ERROR_MUST_BE_LATER_THEN_PARAM').f(
                    $translate.instant('TXT_LBL_END_DATE'),
                    $translate.instant('TXT_LBL_START_DATE')
                )
            }],
        }, {
            label: {
                text: $translate.instant('TXT_PLACE')
            },
            name: "place",
            dataField: "placeId",
            editorType: "dxSelectBox",
            editorOptions: {
                dataSource: classroomDataSource,
                displayExpr: 'name',
                valueExpr: 'id',
                onValueChanged: function (e) {
                    calculatePrice(formData);
                }
            },
            validationRules: [{
                type : "required",
                message: $translate.instant('TXT_ERROR_REQUIRED_WITH_PARAM').f($translate.instant('TXT_PLACE'))
            }],
        }]);        
    }

    var schedulerInstance = null;

    $scope.schedulerOptions = {
        dataSource: scheduleDataSource,
        views: [{
            type: "timelineDay",
            timeCellTemplate: function (itemData, itemIndex, itemElement) {
                return "<div id='time-cell-" + moment(itemData.date).format('HHmm') + "'>" + itemData.text + "</div>";
            },
            resourceCellTemplate: 'resourceCellTemplate'
        }],
        currentView: "timelineDay",
        maxAppointmentsPerCell: "unlimited",
        firstDayOfWeek: 0,
        startDayHour: 7,
        endDayHour: 20,
        cellDuration: 30,
        groups: ["employeeId"],
        crossScrollingEnabled: true,
        currentDate: now,
        editing: {
            allowDragging: false,            
        },
        resources: [{
            fieldExpr: "employeeId",
            valueExpr: "id",
            displayExpr: "fullName",
            allowMultiple: false,           
            label: "Employee",
            useColorAsDefault: true
        }],
        bindingOptions: {
            "resources[0].dataSource": "selectedEmployees "
        },
        height: "100%",
        dataCellTemplate: function(data) {
            return $scope.markAvailable(data) 
            ? "<div class='employee-available'></div>"
            : "";
        },
        appointmentTooltipTemplate: 'tooltip',
        onCellContextMenu: function(e) {
            $scope.cellContextMenuCellData = e.cellData;
            
            if ($(e.cellElement).is(".dx-scheduler-date-table-cell")) {
                var data = {
                    placeId: $scope.selectedClassroom,
                    employeeId: e.cellData.groups.employeeId,
                    startDate: e.cellData.startDate,
                    endDate: e.cellData.endDate
                };
                
                let selectedCellData = e.component.option("selectedCellData");
                
                for (let i = 0; i < selectedCellData.length; i++) { 
                    let cellData = selectedCellData[i];
                    if (cellData) {
                        if (!data.startDate || moment(data.startDate).isAfter(cellData.startDate)) {
                            data.startDate = cellData.startDate;
                        }
                        if (!data.endDate || moment(data.endDate).isBefore(cellData.endDate)) {
                            data.endDate = cellData.endDate;
                        }
                    }
                }
                $scope.cellContextMenuCellData = data;
            }
        },
        onInitialized: function (e) {
            schedulerInstance = e.component;            
        },
        onCellClick: function (e) {
            e.cancel = true;
        },
        onAppointmentFormOpening: function (data) {

            if (data.appointmentData.type == 0) {
                setUpEmployeeReservationForm(data);
            }
            else if (data.appointmentData.type == 1) {
                data.popup.option("minWidth", 700);
                setUpStudentBookingForm(data);                
            }
        },
        onContentReady: function (e) {
            var popupConfig = e.component._popupConfig;

            e.component._popupConfig = function () {
                var popupOptions = popupConfig.apply(e.component, arguments)                

                return $.extend(popupOptions, {
                    height: 'auto',
                });
            }

            scheduleDataSource.load();
        },
        onOptionChanged: function (e) {
            if (e.name == "currentDate" && localStorageService.isSupported) {
                localStorageService.set('reservation-schedule-selected-date', JSON.stringify(e.value));
            }
        },
        onAppointmentRendered: function (e) {
            var origHeight = e.appointmentElement.height();
          //  var offset = (origHeight - 4) / 2;
            switch (e.appointmentData.type) {
                case 0:                    
                    e.appointmentElement.height(18);                    
                    e.appointmentElement.addClass('availability-appointment');
                    break;
                case 1:
                    e.appointmentElement.addClass('reservation-appointment');
                    e.appointmentElement.height(origHeight + origHeight - 20);
                    e.appointmentElement.css('margin-top', -origHeight + 19);
                    e.appointmentElement[0].style.backgroundColor = '#FF676D';
                    break;
            }
            
        }
    };

    $scope.markPlaceAvailable = function (cellData) {

    }
    
    $scope.markAvailable = function (cellData) {
        if (!!employees && !!cellData.groups) {
            let employeeData = employees[cellData.groups.employeeId];
            if (employeeData && employeeData.availability.length > 0) {
                let key = cellData.groups.employeeId + '_' + cellData.startDate.getHours() + '_' + cellData.startDate.getMinutes();
                if (availableCache[key] !== undefined) {
                    return availableCache[key];
                }
                
                let startDate = moment(cellData.startDate);
                let endDate = moment(cellData.endDate);

                let day = moment(startDate).startOf('day').toDate();

                let dayAvailability = _.find(employeeData.availability, { 'day': day });
                 if (dayAvailability) {
                    let coveringPeriod = _.find(dayAvailability.periods, function (p) {
                        let periodStart = moment(p.start);
                        let periodEnd = moment(p.end);

                        let startIndication = periodStart.isSameOrBefore(startDate);
                        let endIndication = periodEnd.isSameOrAfter(endDate);

                        return startIndication && endIndication;
                    });

                    if (coveringPeriod) {
                        availableCache[key] = true;
                        return true;
                    } else {
                        availableCache[key] = false;
                    }
                 }
            }
        }
        return false; 
    };

    $scope.employeeScheduleDelete = function (data) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE',
            message: 'TXT_TEXT_CONFIRM_DELETE',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    schedulerInstance.deleteAppointment(data.appointmentData);
                }
            }]
        });
        schedulerInstance.hideAppointmentTooltip();
    };

    $scope.employeeScheduleEdit = function (data) {
        schedulerInstance.showAppointmentPopup(data.appointmentData);
        schedulerInstance.hideAppointmentTooltip();
    }

    $scope.reservationDelete = function (data) {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE',
            message: 'TXT_TEXT_CONFIRM_DELETE',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    schedulerInstance.deleteAppointment(data.appointmentData);
                }
            }]
        });        
        schedulerInstance.hideAppointmentTooltip();
    };

    $scope.reservationEdit = function (data) {
        schedulerInstance.showAppointmentPopup(data.appointmentData);
        schedulerInstance.hideAppointmentTooltip();
    }

    $scope.reservationCopy = function (data) {
        data.appointmentData.copyMode = true;
        schedulerInstance.showAppointmentPopup(data.appointmentData);
        schedulerInstance.hideAppointmentTooltip();
    }

    $scope.reservationCreatePayment = function (data) {
        addPayment(data.appointmentData);
        schedulerInstance.hideAppointmentTooltip();
    }

    var addPaymentPromise = $modal({
        templateUrl: 'finance/payments/payments-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function addPayment(data) {
        addPaymentPromise.$scope.isAddDuePayment = true;
        addPaymentPromise.$scope.paymentDetail = {
            paymentID: 0,
            invoiceForType: 4,
            invoiceID: data.invoiceId,
            amount: data.arrear,
            selectedDate: moment().toDate(),
        };

        addPaymentPromise.$promise.then(function () {
            addPaymentPromise.$scope.detailError = null;
            addPaymentPromise.$scope.onSave = function () {
                schedulerInstance.repaint();
            }

            addPaymentPromise.show();
        });
    }

    $scope.$on('refreshData', function (e, data) {
        scheduleDataSource.load();

        if (schedulerInstance) {
            schedulerInstance.repaint();
        }
    });

    function onAddUserClick() {
        return $q(function (resolve, reject) {
            var userDetail = userSvc.createNew();

            userDetailDialogPromise.$promise.then(function () {
                userDetailDialogPromise.$scope.userDetail = angular.copy(userDetail);
                userDetailDialogPromise.$scope.preFilled = true;
                userDetailDialogPromise.$scope.userSaved = function (model) {
                    resolve(model);
                }
                userDetailDialogPromise.show();
            });
        });
    }

    function onAddStudentClick() {        
        return $q(function (resolve, reject) {

            if (!selectedUserId) {
                reject();
                return;
            }

            var student = studentSvc.createNew();
            student.userID = selectedUserId;

            studentDialogPromise.$promise.then(function () {
                studentDialogPromise.$scope.collection = [];
                studentDialogPromise.$scope.model = student;
                studentDialogPromise.$scope.preFilled = true;
                studentDialogPromise.$scope.onStudentSave = function (model) {
                    resolve(model);
                };
                studentDialogPromise.show();
            });
        });
    }

    var userDetailDialogPromise = $modal({
        templateUrl: 'users/users-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var studentDialogPromise = $modal({
        templateUrl: 'users/students/students-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
